import * as ng from 'angular';

export const Compile = ($compile: ng.ICompileService) => (<angular.IDirective>{
    link: (scope: any, element: JQLite, attrs: any) => {
        scope.$watch(
            (scope) => {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            },
            (value) => {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);
                // compile the new DOM and link it to the current
                // scope.
                // nOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                // $compile(element.contents())(scope);
                $compile(element.children())(scope);
            }
        );
    }
});

Compile.$inject = ['$compile'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/compile/compile.directive.ts